import { CartMinimalGeoCode } from '../types';

/**
 * Return whether or not two geo codes are equal
 */
const geoCodesAreEqual = (a: CartMinimalGeoCode, b: CartMinimalGeoCode) => a && b && (
    a.geoCode === b.geoCode
    && a.city === b.city
    && a.state === b.state
);

export default geoCodesAreEqual;
